import { Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class SettingsValuesService {


  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  public get BaseURL() {
    return this._SettingsService['BaseURL'];
  }
  public get CustId() {
    return this._SettingsService['CustId'];
  }
  public get Facility() {
    return this._SettingsService['Facility'];
  }
  public get FootprintApi() {
    return this._SettingsService['FootprintApi'];
  }
  public get MongoDb() {
    return this._SettingsService['MongoDb'];
  }
  public get Port() {
    return this._SettingsService['Port'];
  }
  public get Token() {
    return this._SettingsService['Token'];
  }

  public app: SettingsValuesService = this;

  public get Utilities() {
     return {
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb
    };
  }
  public get IntraOne() {
     return {
BaseURL : this.BaseURL,
CustId : this.CustId,
Facility : this.Facility,
FootprintApi : this.FootprintApi,
MongoDb : this.MongoDb,
Port : this.Port,
Token : this.Token
    };
  }
}
